<template>
  <div class="bmi-content" v-if="bmiData">
    <div class="top">
      <div class="top-container">
        <div class="c-top">
          <div class="c-title">我的BMI指数</div>
        </div>
        <BmiCanvas v-if="bmi" class="bmi-container" :value="bmi" />
        <div class="tip-c" v-if="bmiData">
          <div class="tip-title">
            <div class="line"></div>
            <div class="title" v-if="bmiData.bmiStatus != 1">风险提示</div>
            <div class="title" v-else>可持续优化</div>
            <div class="line"></div>
          </div>
          <div class="tag-list">
            <div
              class="tag-item"
              :class="{ 'tag-item-risk': bmiData.bmiStatus != 1 }"
              v-for="(item, index) in bmiData.warningLab"
              :key="index"
            >
              {{ item }}
            </div>
          </div>
        </div>
      </div>
      <BannerText class="banner-container" :data="bannerTextList"></BannerText>
    </div>
    <div class="bottom">
      <div class="bmi-item">
        <div class="item-title">什么是BMI？</div>
        <div>
          <div>
            BMI：成年人身体质量指数，是目前国际上相对可靠、常用的一种衡量人体胖瘦程度以及健康状况的指标，适用于我国成年人。
          </div>
          <div class="item-margin">计算公式：体重（KG）/身高（M）²</div>
          <div class="item-desc">
            *BMI没有考虑体脂比例，对于孕妇、哺乳期妇女、老人及身型壮硕的运动员以及其他体脂率异常者并不适用
          </div>
        </div>
      </div>
      <div class="bmi-item">
        <div class="item-title">BMI正常范围应是多少？</div>
        <div>
          <div class="bmi-list">
            <div
              class="list-item"
              v-for="(item, index) in bmiList"
              :key="index"
            >
              <img class="bmi-image" :src="item.image" />
              <div>{{ item.text }}</div>
              <div>{{ item.range }}</div>
            </div>
          </div>
          <div class="bmi-line">
            <div class="line-scroll">
              <div
                class="left"
                :style="{ flex: '0 0 ' + (curWidth + 'px') }"
              ></div>
              <div class="dot">
                <div class="text">您在这里</div>
              </div>
              <div class="right"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="bmi-item">
        <div class="item-title">长期处于非正常BMI会怎样？</div>
        <!--  -->
        <div v-if="bmiData.bmiStatus > 1">
          <div class="item-margin">
            BMI不仅代表了我们的身材是否良好，更是一定程度上反映了我们的身体健康程度。
          </div>
          <div class="item-margin">
            如果我们体内的脂肪沉积过多，尤其是在腹壁或者腹腔内蓄积过多，对我们的身体会造成非常大的影响，这种情况我们称之为中心型或者是向心型肥胖。
          </div>
          <div class="item-margin">
            <span>如果BMI值大于24，患者患</span>
            <span class="pink">高血压</span>
            <span>的风险是正常人群的3-4倍，患</span>
            <span class="pink">糖尿病</span>
            <span>的风险是正常体重人群的2-3倍，而且也会增加患</span>
            <span class="pink"
              >心脑血管疾病、呼吸系统疾病、骨关节炎、脑卒中、缺血性脑卒中</span
            >
            <span>已及增加患</span>
            <span class="pink">癌症</span>
            <span>的风险。</span>
          </div>
        </div>
        <!--  -->
        <div v-if="bmiData.bmiStatus < 1">
          <div class="item-margin">
            BMI不仅代表了我们的身材是否良好，更是一定程度上反映了我们的身体健康程度。
          </div>
          <div class="item-margin">
            常见的比如饮食结构不合理、长期吸烟酗酒、缺乏适当运动、缺少睡眠、压力过大等，这些都可以引起BMI异常。
          </div>
          <div>
            当自身的BMI指数出现了<span class="pink">低于正常值</span
            >的情况时，应当立刻开始注意自身身体状况了！BMI过低，不仅会<span
              class="pink"
              >影响体态</span
            >，而且还会容易导致自己出现<span class="pink"
              >易疲倦、体力差、身体抵抗力降低、免疫力差、耐寒抗病能力弱</span
            >的情况，使得身体易患多种疾病，例如<span class="pink"
              >脱发、贫血、骨质疏松、不孕症、胆结石、胃下垂</span
            >等高发性健康问题。
          </div>
        </div>
        <div v-if="bmiData.bmiStatus == 1">
          <div class="item-margin">
            BMI不仅代表了我们的身材是否良好，更是一定程度上反映了我们的身体健康程度。
          </div>
          <!-- <div class="item-margin">
            长期的国际研究表明，当BMI长期处于非正常数值时，不仅会影响患者的体态，其患<span
              class="pink"
              >高血压、高血脂</span
            >的风险是正常人群的3-4倍，患<span class="pink">糖尿病</span
            >的风险是正常BMI人群的2-3倍，而且还会增加一系列并发症比如<span
              class="pink"
              >心脑血管疾病、内分泌系统功能紊乱、生殖能力下降</span
            >等危险疾病发生的风险。
          </div> -->
          <div class="item-title">BMI正常，就一定健康吗？</div>
          <div class="item-margin">
            由于BMI没有考虑体脂比例，所以即使是正常数值的BMI，也可能出现脂肪过量累积的问题。这样的体态，通常是看起来非常苗条，而摸上去又很有“肉感”，<span
              class="pink"
              >腰围比较大，四肢相对较小</span
            >，这部分人BMI标准或偏轻，但身体内脂肪的含量却很高，<span
              class="pink"
              >体脂率已经达到了肥胖标准</span
            >，称为<span class="pink">向心型肥胖</span>。
          </div>
          <!-- <div class="item-margin">
            向心型肥胖与多种<span class="pink">慢性病</span
            >发生风险显著相关，且有明显的饮食结构不合理问题，容易造成<span
              class="pink"
              >易疲倦、体力差、身体抵抗力降低、免疫力差、脱发、皮肤暗黄长痘</span
            >等长期困扰。
          </div> -->
        </div>
      </div>
      <!-- 建议 -->
      <div class="bmi-item">
        <div class="item-title">建议</div>
        <div v-if="bmiData.bmiStatus == 1">
          <div class="item-margin item-bold">自查脂肪分布情况：</div>
          <div class="item-margin">
            状态是最好的风水，BMI数值正常的情况下，建议关注自己的腰围尺寸是否为肥胖的标准，如果男性腰围超过90cm或腰臀比＞0.9，女性超过80cm或腰臀比＞0.85，则为向心性肥胖。
          </div>
          <div class="item-margin item-bold">改变饮食习惯：</div>
          <div class="item-margin">
            <span class="pink">切忌不吃主食、不吃肉只吃菜和不吃晚餐</span
            >的行为，建议首先从科学<span class="pink">调整饮食结构</span
            >和进食时间着手，提高蔬菜、水果、谷物和蛋白质在自己饮食中的占比，慢慢接触营养学知识，<span
              class="pink"
              >学会餐食营养搭配</span
            >，从<span class="blue" @click="bindLink(0)">了解超级食物 ></span
            >开始，在保障能<span class="pink">吃饱、吃好，绝不挨饿</span
            >的前提下轻松控制体重。只要你掌握了饮食的搭配密码，就能越吃越瘦，迅速感受到身体带来的反馈。
          </div>
          <div class="item-margin item-bold">坚持适当运动：</div>
          <div class="item-margin">
            BMI
            正常的人群，运动的目的是改善脂肪代谢，优化肌肉线条，进行轻中度的运动即可。一周3次，时间在
            30分钟以上 60 分钟以内。在betterWE星球上，有许多免费的<span
              class="blue"
              @click="bindLink(1)"
              >明星达人运动课程 ></span
            >，可以每周跟练3-4次哦！
          </div>
        </div>
        <div v-else>
          <div class="item-margin item-bold">改变饮食习惯：</div>
          <div class="item-margin">
            <span class="pink">切忌不吃主食、不吃肉只吃菜和不吃晚餐</span
            >的行为，建议首先从科学<span class="pink">调整饮食结构</span
            >和进食时间着手，提高蔬菜、水果、谷物、蛋白质<span
              v-if="bmiData.bmiStatus < 1"
              >和优质油脂</span
            >在自己饮食中的占比，慢慢接触营养学知识，<span class="pink"
              >学会餐食营养搭配</span
            >，从<span class="blue" @click="bindLink(0)">了解超级食物 ></span
            >开始，在保障能<span class="pink">吃饱、吃好，绝不挨饿</span
            >的前提下调理肠胃吸收与消化系统。只要你掌握了饮食的搭配密码，就能越吃越健康，迅速感受到身体带来的反馈。
          </div>
          <div class="item-margin item-bold">坚持适当的运动：</div>
          <div class="item-margin">
            每周要有不少于3次，每次大约60分钟的有氧运动。在betterWE星球上，有许多<span
              class="pink"
              >免费的</span
            ><span class="blue" @click="bindLink(1)">明星达人运动课程 ></span
            >，可以每周跟练3-4次哦！
          </div>
          <div class="item-margin item-bold">保持乐观的心态和生活习惯：</div>
          <div class="item-margin">
            如今生活压力不断增大，因此平时要学会调整好自己的心态，尤其不要在无聊或者压力大的时候海吃海喝。平时也要保证充足睡眠，夜间不要熬夜。
          </div>
        </div>
      </div>
    </div>
    <BannerImage class="banner-image" :data="bannerImageList"></BannerImage>
  </div>
</template>
<script>
import BmiCanvas from './bmi-component.vue'
import BannerText from './banner-text.vue'
import BannerImage from './banner-image.vue'
export default {
  components: {
    BmiCanvas,
    BannerText,
    BannerImage
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      bmi: null,
      bmiData: null,
      bannerImageList: [],
      bannerTextList: [],
      bmiList: [
        {
          text: '偏瘦',
          range: '16-18.5',
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/aa70c1964dd0c2586087ed3b64520e2b.png',
          min: 16,
          max: 18.5
        },
        {
          text: '标准',
          range: '18.5-24',
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/9a7384e4e66914fab179a074ccc60a25.png',
          min: 18.6,
          max: 24
        },
        {
          text: '偏重',
          range: '24-28',
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/b15e91add3f17d3748de7e3e51cdd8da.png',
          min: 24.1,
          max: 28
        },
        {
          text: '肥胖',
          range: '28-31',
          image:
            '	https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/8966a0cbea2e435c291899c8264e6f65.png',
          min: 28.1,
          max: 31
        },
        {
          text: '重度肥胖',
          range: '31-35',
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a8f515a8eb9582e8b8b3493c30ab0e71.png',
          min: 31.1,
          max: 35
        }
      ]
    }
  },
  computed: {
    curWidth() {
      let dotDesignWidth = 24 //点加间距的宽度是24px
      let parentDesiginWidth = 295
      let screenWidth = window.screen.width
      let dotWidth = (dotDesignWidth * screenWidth) / 375
      let parentWidth = (parentDesiginWidth * screenWidth) / 375
      let width = parentWidth * this.percent - dotWidth / 2
      width = width < 0 ? 0 : width
      return width
    },
    percent() {
      if (!this.bmi) {
        return 0
      }
      let index
      for (let i = 0; i < this.bmiList.length; i++) {
        let item = this.bmiList[i]
        if (this.bmi >= item.min && this.bmi <= item.max) {
          index = i
          break
        }
      }
      if (index === undefined) {
        index = this.bmi < this.bmiList[0].max ? 0 : this.bmiList.length - 1
      }
      let space = 0.01355
      let perItem =
        (1 - space * (this.bmiList.length - 1)) / this.bmiList.length
      let spaceCount = index
      let percent =
        (this.bmi - this.bmiList[index].min) /
        (this.bmiList[index].max - this.bmiList[index].min)
      percent = percent > 1 ? 1 : percent
      let per = perItem * index + space * spaceCount + perItem * percent
      return per
    }
  },
  created() {
    this.getBannerTextData()
    this.getBannerImageData()
    this.getBmi()
  },
  methods: {
    getBannerTextData() {
      let params = {
        position_type: '5', //位置类型
        resource_type: '3' //资源位类型
      }
      this.$http
        .getAdvData(
          'member/ResourceLocation/getShowResourceLocationNew',
          params
        )
        .then((res) => {
          res = res.data
          if (res.code === 200) {
            this.bannerTextList = res.data
          }
        })
        .catch((err) => {})
    },
    getBannerImageData() {
      let params = {
        position_type: '5', //位置类型
        resource_type: '2' //资源位类型
      }
      this.$http
        .getAdvData(
          'member/ResourceLocation/getShowResourceLocationNew',
          params
        )
        .then((res) => {
          res = res.data
          if (res.code === 200) {
            this.bannerImageList = res.data
          }
        })
        .catch((err) => {})
    },
    bindLink(index) {
      switch (index) {
        case 0:
          this.$router.push('/calorie-query/index')
          break
        case 1:
          this.jumpCourse()
          break
      }
    },
    jumpCourse() {
      if (this.$http._isApp()) {
        let obj = {
          path: '/starVideoList', //跳转页面路径
          //跳转所需参数
          params: []
        }
        this.$betterwe.onAppPageRoute(obj)
      } else {
        this.$toast('请前往APP打开')
      }
    },
    //更新记录
    updateRecord(value) {
      this.setBmi(value)
    },
    setBmi(value) {
      console.log(this)
      let params = {
        data_field: this.data.field,
        data_value: value
      }
      this.$http
        .postAppWithAppInfo('member/UserBodyData/addUserBodyData', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.$toast('添加成功')
            this.getBmi()
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loaded = true
        })
    },
    //获取bmi数据
    getBmi() {
      this.$http
        .getApp('member/UserBodyData/getUserBmiExplain', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            res.data.bmiStatus = this.computeBmi(res.data.bmi)
            this.bmiData = res.data
            this.bmi = parseFloat(res.data.bmi)
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    computeBmi(bmi) {
      let index
      let arr = [
        {
          min: -Infinity,
          max: 18.5
        },
        {
          min: 18.5,
          max: 24
        },
        {
          min: 24,
          max: 28
        },
        {
          min: 28,
          max: Infinity
        }
      ]
      for (let i = 0; i < arr.length; i++) {
        if (bmi > arr[i].min && bmi <= arr[i].max) {
          index = i
          break
        }
      }
      return index
    }
  }
}
</script>
<style lang="scss" scoped>
.bmi-content {
  background: #f9f9f9;
  overflow: hidden;
  padding-bottom: 50px;
}
.bmi-container {
  width: 100%;
  height: 188px;
}
.bottom {
  background: #f9f9f9;
  padding: 20px 20px 0px;
  box-sizing: border-box;
}
.bmi-item {
  background: #ffffff;
  border-radius: 12px;
  padding: 15px 20px;
  box-sizing: border-box;
  margin-bottom: 16px;
  font-size: 12px;
  //font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.5);
  line-height: 22px;
  .item-title {
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
    line-height: 20px;
    margin-bottom: 10px;
  }
  .item-desc {
    color: rgba(0, 0, 0, 0.3);
  }
  .item-margin {
    margin-bottom: 10px;
  }
  .item-bold {
    font-weight: 600;
  }
  .pink {
    color: #ff8c9c;
  }
  .blue {
    color: #6236ff;
    text-decoration: underline;
  }
  .bmi-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 10px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4a3d6b;
    line-height: 14px;
    text-align: center;
    margin-bottom: 10px;
    .list-item {
      width: 56px;
    }
    .bmi-image {
      height: 92px;
      border-radius: 4px;
      overflow: hidden;
      margin-bottom: 10px;
    }
  }
  .bmi-line {
    height: 4px;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    .line-scroll {
      min-width: 100%;
      height: 100%;
      display: inline-flex;
      align-items: center;
    }
    .left {
      width: 0px;
      height: 100%;
      background: #f7f7f7;
      border-radius: 6px;
    }
    .dot {
      flex: 0 0 8px;
      width: 8px;
      height: 8px;
      background: rgba(74, 61, 107, 1);
      border-radius: 6px;
      margin: 0px 8px;
      position: relative;
      animation: star 3s linear infinite;
      .text {
        white-space: nowrap;
        position: absolute;
        left: 50%;
        top: 12px;
        transform: translate(-50%, 0%);
        height: 17px;
        background: #4a3d6b;
        border-radius: 6px;
        font-size: 10px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 17px;
        padding: 0px 7px;
      }
    }
    .right {
      flex: 1;
      height: 100%;
      background: #f7f7f7;
      border-radius: 6px;
    }
  }
}
.tip-c {
  margin-top: 30px;
  .tip-title {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .line {
      flex: 1;
      flex-shrink: 0;
      height: 0px;
      border-bottom: 1px dashed rgba(255, 255, 255, 0.5);
    }
    .title {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #ffffff;
      line-height: 17px;
      margin: 0px 13px;
    }
  }
  .tag-list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
    .tag-item {
      line-height: 22px;
      background: #44c06b;
      border-radius: 4px;
      padding: 0px 12px;
      margin: 3px;
      font-size: 10px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      white-space: nowrap;
    }
    .tag-item-risk {
      background: #ff6379;
    }
  }
}
.top {
  display: flex;
  align-items: stretch;
  flex-direction: column;
  margin-bottom: 24px;
  background-color: #4a3d6b;
  .top-container {
    box-sizing: border-box;
    padding: 0px 20px 20px;
  }
}
.c-top {
  display: flex;
  align-items: center;
  margin-bottom: 22px;
  box-sizing: border-box;
  .c-title {
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 25px;
  }
  .c-unit {
    flex: 1;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.7);
    line-height: 17px;
    margin-left: 10px;
    margin-right: 10px;
  }
  .c-btn {
    height: 25px;
    line-height: 25px;
    padding: 0px 12px;
    background: #ffffff;
    border-radius: 10px;
    border: 2px solid #6236ff;
    font-size: 13px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #6236ff;
  }
}
.banner-container {
  margin-bottom: 20px;
}
.banner-image {
  margin-bottom: 20px;
}
@keyframes star {
  0% {
    background: rgba(74, 61, 107, 1);
  }
  50% {
    background: rgba(74, 61, 107, 0);
  }
  100% {
    background: rgba(74, 61, 107, 1);
  }
}
</style>
